import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { formatMoney } from 'shared/util/formatting';
import type { Money } from 'shared/util/money';
import { GOVERNMENT_TOURIST_TAX } from '@/constants';

type TouristTaxDetailProps = {
    money: Money;
};

export const TouristTaxDetail = ({ money }: TouristTaxDetailProps) => {
    const [showInfo, setShowInfo] = useState(false);

    return (
        <>
            <div className="flex justify-between my-8">
                <Button
                    link
                    className="s-text text-14 text-left"
                    onClick={() => setShowInfo(!showInfo)}
                    aria-expanded={showInfo}
                    aria-controls="tourist-tax-info">
                    Besøksavgift
                </Button>
                <data className="text-14" value={money.value}>
                    {formatMoney(money, 2)}
                </data>
            </div>
            {showInfo && (
                <p id="tourist-tax-info" className="text-left text-12 s-text-subtle pb-10">
                    Besøksavgift er en avgift besøkende betaler for å bidra til drift og vedlikehold av fellesområder og tilbud på
                    reisemålet.
                    <Button small link href={`${GOVERNMENT_TOURIST_TAX}`} target="_blank" rel="noreferrer" className="ml-4">
                        Les mer om besøksavgift.
                    </Button>
                </p>
            )}
        </>
    );
};
